import Milenialb1 from "./milenialb (1).webp";
import Milenialb2 from "./milenialb (2).webp";
import Milenialb3 from "./milenialb (3).webp";
import Milenialb4 from "./milenialb (4).webp";
import Milenialb5 from "./milenialb (5).webp";
import Milenialb6 from "./milenialb (6).webp";
import Milenialb7 from "./milenialb (7).webp";

const milenialb = [
  Milenialb1,
  Milenialb2,
  Milenialb3,
  Milenialb4,
  Milenialb5,
  Milenialb6,
  Milenialb7,
];

export default milenialb;
